import React from 'react'
import { graphql } from 'gatsby'
import Image from 'gatsby-image';
import Layout from '../components/layout'
import Banner from '../components/banner'

const Research = ({ data }) => {
  data.research.edges.sort((a, b) => {
    return b.node.frontmatter.paper_year[0] - a.node.frontmatter.paper_year[0]
  })
  return (
    <Layout
      title="Research"
      description="Research"
      lang="ja"
    >
      <Banner message="Research"></Banner>
      {
        data.sumally.edges.map(({ node }, idx) => (
          <div className="container section" key={idx}>
            <p className="text-size-6 text-color-light">{node.frontmatter.description}</p>
          </div>
        ))
      }

      {
        data.research.edges.map(({ node }, idx) => (
          <div className="container section" key={idx}>
            <p className="text-size-5 text-weight-semibold heading">{node.frontmatter.title}</p>
            <div className="columns">
              <div className="col-12 col-tablet-12 col-mobile-12">
                <p>{node.frontmatter.description}</p>
                <p>(<a href={node.frontmatter.link}>プレスリリースに移動します</a>)</p>
              </div>
              <div className="col-3 col-tablet-2 col-mobile-12"></div>
              <div className="col-6 col-tablet-8 col-mobile-12 heading">
                <Image fluid={ node.frontmatter.image.childImageSharp.fluid } />
              </div>
              <div className="col-3 col-tablet-2 col-mobile-12"></div>
            </div>
            <ul className="research">
              {
                node.frontmatter.paper_authors.map((cur, idx) => {
                  let p

                  p = ''
                  p += node.frontmatter.paper_authors[idx]
                  p += '(' + node.frontmatter.paper_year[idx] + '). '
                  p += node.frontmatter.paper_title[idx] + ' '
                  p += node.frontmatter.paper_journal[idx]
                  
                  return (
                    <li dangerouslySetInnerHTML={{__html: p}} key={idx} />
                  )
                })
              }
            </ul>
          </div>
        ))
      }
    </Layout>
  )
}

export default Research

export const query = graphql`
query ResearchQuery {
  sumally: allMarkdownRemark(
    filter: {
      frontmatter: {
        type: {eq: "researchSummary"}
      }
    }
    ) {
    edges {
      node {
        frontmatter {
          description
        }
      }
    }
  }

  research: allMarkdownRemark(
    filter: {
      frontmatter: {
        type: {eq: "research"}
      }
    }
    ) {
    edges {
      node {
        frontmatter {
          title
          description
          link
          paper_authors
          paper_year
          paper_title
          paper_journal
          image {
            childImageSharp {
              fluid ( maxWidth: 1000 ) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
}
`;